import { render, staticRenderFns } from "./StudentLocation.vue?vue&type=template&id=459a9540&"
import script from "./StudentLocation.vue?vue&type=script&lang=js&"
export * from "./StudentLocation.vue?vue&type=script&lang=js&"
import style0 from "./StudentLocation.vue?vue&type=style&index=0&id=459a9540&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports